import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms'
import { isEmail } from 'validator';
import { trim } from 'lodash';

import { User } from '../user';

const ALPHABET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const NUMERIC = '0123456789';
const SYMBOL = '*#$!?/<>&-_';

function newPassword() {
  let length = 12;
  let password = '';
  let charset = '';

  // Create charset
  for (let i = 0; i < 256; ++i) {
    charset += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    charset += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    charset += NUMERIC.charAt(Math.floor(Math.random() * NUMERIC.length));
    charset += SYMBOL.charAt(Math.floor(Math.random() * SYMBOL.length));
  }
  
  // Create password
  for (let i = 0, n = charset.length; i < length; ++i) {
    password += charset.charAt(Math.floor(Math.random() * n));
  }

  return password;
}



@Component({
  selector: 't-user-auth',
  templateUrl: './auth.component.html',
})
export class UserAuthComponent implements OnInit {

  @Input()
  user: User

  passwordVisible = false

  username: FormControl
  password: FormControl

  constructor(private builder: FormBuilder) {}

  ngOnInit() {
    // Username
    this.username = new FormControl(this.user.username, [
      Validators.required,
      (input: FormControl) => {
        let valid = input.value === '' || isEmail(input.value);
        return valid ? null : { email: true };
      }
    ]);

    this.username.valueChanges.subscribe((value) => {
      this.user.username = value;
    });


    // Password
    this.password = new FormControl(this.user.password, [
      // Validate that password is required when a new user
      (input: FormControl) => {
        // Ignore this validator for a existing user
        if(this.user.id) {
          return null;
        }

        let value = trim(input.value);
        let valid = value.length > 0;
        return valid ? null : { minlength: true };
      },
      Validators.minLength(8)
    ]);

    this.password.valueChanges.subscribe((value) => {
      this.user.password = value;
    });
  }

  generatePassword(event: Event) {
    this.password.patchValue(newPassword());

    this.passwordVisible = true;
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  submit(a: any) {
    console.log(a.valid);
  }
}
